import type { QueryClient } from '@tanstack/react-query';
import {
  broadcastKeys,
  type AdminBroadcastDetail,
  type BroadcastScope,
} from '../queries/broadcasts';

// A save returns the full updated broadcast, so its detail entry is written
// directly. The rendered-email preview is derived from the fields just saved,
// so it is refetched rather than left showing the previous version.
export function cacheSavedBroadcast(
  qc: QueryClient,
  scope: BroadcastScope,
  saved: AdminBroadcastDetail,
): void {
  qc.setQueryData(broadcastKeys.detail(scope, saved.id).queryKey, saved);
  void qc.invalidateQueries({
    queryKey: broadcastKeys.preview(scope, saved.id).queryKey,
  });
}
